export enum SnippetType {
  New,
  Existing,
}
